import * as actionTypes from '../actions/actionTypes';
import axios from 'axios';

export const setLowestFare = (lowestFare) => {
    return {
        type: actionTypes.SET_LOWEST_FARE,
        lowestFare: lowestFare
    }
}

export const getLowestFareFailed = () => {
    return {
        type: actionTypes.GET_LOWEST_FARE_FAILED
    }
}

export const getLowestFare = (lowestFareParams) => {
    return dispatch => {
        axios.get('https://flight.yatra.com/lowest-fare-service/b2bdom/get-fare?' + lowestFareParams)
            .then(response => {
                dispatch(setLowestFare(JSON.parse(response.data)));
            })
            .catch(error => {
                console.log(error);
                dispatch(getLowestFareFailed());
            })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/lowestFare.js